<template>
  <div class="inner-tab-wrapper mb-4">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div data-type="policy-tech-data">
          <details-card
            v-for="(item, index) in detailFieldsTechData"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
            <!-- :labels="labels" -->
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsGuarantees"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
            <!-- :labels="labels" -->
          </details-card>
          <!-- -->
          <details-card
            v-for="(item, index) in detailFieldsRca"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsFurInc"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsKasko"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsEasyKask"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsComplRca"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsComplArd"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsEvNat"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsEvSocPol"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsCrist"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFieldsAltro"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @update="onUpdate"
          >
          </details-card>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <!-- <base-icon name="loading" width="35" height="35" /> -->
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShowMixin from "@/mixins/ShowMixin";
import FormMixin from "@/mixins/FormMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import DetailsCard from "@/components/DetailsCard";

export default {
  mixins: [FormMixin, ShowMixin],
  name: "TechnicalData",
  props: {
    resourceId: Number,
  },
  components: {
    DetailsCard,
  },
  data() {
    return {
      isLoading: false,
      repository: "insurance_policy",
      allRepositories: [],
      details: null,
      defaultLabels: {},
      mandatoryFields: {
        insurance_policy: {},
      },
      detailFields1: {
        veicolo: {
          header: "Dati Veicolo",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_BRAN_value",
                "insurance_policy"
              ),
              value: "attributables.BRAN",
            },
            {
              label: this.getDictionary(
                "attribute_CANIA_value",
                "insurance_policy"
              ),
              value: "attributables.CANIA",
            },
            {
              label: this.getDictionary(
                "attribute_KWHP_value",
                "insurance_policy"
              ),
              value: "attributables.KWHP",
            },
            {
              label: this.getDictionary(
                "attribute_LESC_value",
                "insurance_policy"
              ),
              value: "attributables.LESC",
            },
            {
              label: this.getDictionary(
                "attribute_MODL_value",
                "insurance_policy"
              ),
              value: "attributables.MODL",
            },
            {
              label: this.getDictionary(
                "attribute_NCLBC_value",
                "insurance_policy"
              ),
              value: "attributables.NCLBC",
            },
            {
              label: this.getDictionary(
                "attribute_NCLB_value",
                "insurance_policy"
              ),
              value: "attributables.NCLB",
            },
            {
              label: this.getDictionary(
                "attribute_OVALU_value",
                "insurance_policy"
              ),
              value: "attributables.OVALU",
            },
            {
              label: this.getDictionary(
                "attribute_POW_value",
                "insurance_policy"
              ),
              value: "attributables.POW",
            },
            {
              label: this.getDictionary(
                "attribute_QMTR_value",
                "insurance_policy"
              ),
              value: "attributables.QMTR",
            },
            {
              label: this.getDictionary(
                "attribute_QTTR_value",
                "insurance_policy"
              ),
              value: "attributables.QTTR",
            },
            {
              label: this.getDictionary(
                "attribute_REGM_value",
                "insurance_policy"
              ),
              value: "attributables.REGM",
            },
            {
              label: this.getDictionary(
                "attribute_REGY_value",
                "insurance_policy"
              ),
              value: "attributables.REGY",
            },
            {
              label: this.getDictionary(
                "attribute_REPL_value",
                "insurance_policy"
              ),
              value: "attributables.REPL",
            },
            {
              label: this.getDictionary(
                "attribute_SANIA_value",
                "insurance_policy"
              ),
              value: "attributables.SANIA",
            },
            {
              label: this.getDictionary(
                "attribute_SETP_value",
                "insurance_policy"
              ),
              value: "attributables.SETP",
            },
            {
              label: this.getDictionary(
                "attribute_STNO_value",
                "insurance_policy"
              ),
              value: "attributables.STNO",
            },
            {
              label: this.getDictionary(
                "attribute_STTL_value",
                "insurance_policy"
              ),
              value: "attributables.STTL",
            },
            {
              label: this.getDictionary(
                "attribute_STTR_value",
                "insurance_policy"
              ),
              value: "attributables.STTR",
            },
            {
              label: this.getDictionary(
                "attribute_TXHP_value",
                "insurance_policy"
              ),
              value: "attributables.TXHP",
            },
            {
              label: this.getDictionary(
                "attribute_UANIA_value",
                "insurance_policy"
              ),
              value: "attributables.UANIA",
            },
            {
              label: this.getDictionary(
                "attribute_VALU_value",
                "insurance_policy"
              ),
              value: "attributables.VALU",
            },
            {
              label: this.getDictionary(
                "attribute_VEHT_value",
                "insurance_policy"
              ),
              value: "attributables.VEHT",
            },
            {
              label: this.getDictionary(
                "attribute_WEIG_value",
                "insurance_policy"
              ),
              value: "attributables.WEIG",
            },
          ],
        },
      },
      detailFields2: {
        garanzie: {
          header: "Garanzie",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_RCA_value",
                "insurance_policy"
              ),
              value: "attributables.RCA",
            },
            {
              label: this.getDictionary(
                "attribute_INCFUR_value",
                "insurance_policy"
              ),
              value: "attributables.INCFUR",
            },
            {
              label: this.getDictionary(
                "attribute_KASK_value",
                "insurance_policy"
              ),
              value: "attributables.KASK",
            },
            {
              label: this.getDictionary(
                "attribute_EKASK_value",
                "insurance_policy"
              ),
              value: "attributables.EKASK",
            },
            {
              label: this.getDictionary(
                "attribute_CRCA_value",
                "insurance_policy"
              ),
              value: "attributables.CRCA",
            },
            {
              label: this.getDictionary(
                "attribute_CARD_value",
                "insurance_policy"
              ),
              value: "attributables.CARD",
            },
            {
              label: this.getDictionary(
                "attribute_PPARD_value",
                "insurance_policy"
              ),
              value: "attributables.PPARD",
            },
            {
              label: this.getDictionary(
                "attribute_ENAT_value",
                "insurance_policy"
              ),
              value: "attributables.ENAT",
            },
            {
              label: this.getDictionary(
                "attribute_ESOC_value",
                "insurance_policy"
              ),
              value: "attributables.ESOC",
            },
            {
              label: this.getDictionary(
                "attribute_CRI_value",
                "insurance_policy"
              ),
              value: "attributables.CRI",
            },
            {
              label: this.getDictionary(
                "attribute_RPAT_value",
                "insurance_policy"
              ),
              value: "attributables.RPAT",
            },
            {
              label: this.getDictionary(
                "attribute_ASS_value",
                "insurance_policy"
              ),
              value: "attributables.ASS",
            },
          ],
        },
      },
      detailFields3: {
        dettaglio_rca: {
          header: "Dettaglio RCA",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_RCATI_value",
                "insurance_policy"
              ),
              value: "attributables.RCATI",
            },
            {
              label: this.getDictionary(
                "attribute_RCABM_value",
                "insurance_policy"
              ),
              value: "attributables.RCABM",
            },
            {
              label: this.getDictionary(
                "attribute_RCATG_value",
                "insurance_policy"
              ),
              value: "attributables.RCATG",
            },
            {
              label: this.getDictionary(
                "attribute_RCASC_value",
                "insurance_policy"
              ),
              value: "attributables.RCASC",
            },
            {
              label: this.getDictionary(
                "attribute_RCAMAX_value",
                "insurance_policy"
              ),
              value: "attributables.RCAMAX",
            },
          ],
        },
      },
      detailFields4: {
        dettaglio_fur_inc: {
          header: "Dettaglio FURTO/INCENDIO",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_INCSC_value",
                "insurance_policy"
              ),
              value: "attributables.INCSC",
            },
            {
              label: this.getDictionary(
                "attribute_INCSCIM_value",
                "insurance_policy"
              ),
              value: "attributables.INCSCIM",
            },
            {
              label: this.getDictionary(
                "attribute_INCTA_value",
                "insurance_policy"
              ),
              value: "attributables.INCTA",
            },
            {
              label: this.getDictionary(
                "attribute_INCSCO_value",
                "insurance_policy"
              ),
              value: "attributables.INCSCO",
            },
            {
              label: this.getDictionary(
                "attribute_INCFURSC_value",
                "insurance_policy"
              ),
              value: "attributables.INCFURSC",
            },
            {
              label: this.getDictionary(
                "attribute_IINCFUSCI_value",
                "insurance_policy"
              ),
              value: "attributables.INCFUSCI",
            },
            {
              label: this.getDictionary(
                "attribute_INCFURTA_value",
                "insurance_policy"
              ),
              value: "attributables.INCFURTA",
            },
            {
              label: this.getDictionary(
                "attribute_INCFURSO_value",
                "insurance_policy"
              ),
              value: "attributables.INCFURSO",
            },
          ],
        },
      },
      detailFields5: {
        dettaglio_kasko: {
          header: "Dettaglio KASKO",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_KASKFOR_value",
                "insurance_policy"
              ),
              value: "attributables.KASKFOR",
            },
            {
              label: this.getDictionary(
                "attribute_KASKTA_value",
                "insurance_policy"
              ),
              value: "attributables.KASKTA",
            },
            {
              label: this.getDictionary(
                "attribute_KASKSCO_value",
                "insurance_policy"
              ),
              value: "attributables.KASKSCO",
            },
            {
              label: this.getDictionary(
                "attribute_KASKSC_value",
                "insurance_policy"
              ),
              value: "attributables.KASKSC",
            },
          ],
        },
      },
      detailFields6: {
        dettaglio_easy_kasko: {
          header: "Dettaglio EASYKASKO",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_EKASKMXR_value",
                "insurance_policy"
              ),
              value: "attributables.EKASKMXR",
            },
            {
              label: this.getDictionary(
                "attribute_EKASKTIF_value",
                "insurance_policy"
              ),
              value: "attributables.EKASKTIF",
            },
            {
              label: this.getDictionary(
                "attribute_EKASKFOF_value",
                "insurance_policy"
              ),
              value: "attributables.EKASKFOF",
            },
            {
              label: this.getDictionary(
                "attribute_EKASKIMF_value",
                "insurance_policy"
              ),
              value: "attributables.EKASKIMF",
            },
          ],
        },
      },
      detailFields7: {
        dettaglio_compl_rca: {
          header: "Dettaglio COMPLEMENTARE RCA",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_CRCATA_value",
                "insurance_policy"
              ),
              value: "attributables.CRCATA",
            },
            {
              label: this.getDictionary(
                "attribute_CRCASC_value",
                "insurance_policy"
              ),
              value: "attributables.CRCASC",
            },
          ],
        },
      },
      detailFields8: {
        dettaglio_compl_ard: {
          header: "Dettaglio COMPLEMENTARE ARD",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_CARDTA_value",
                "insurance_policy"
              ),
              value: "attributables.CARDTA",
            },
            {
              label: this.getDictionary(
                "attribute_CARDSC_value",
                "insurance_policy"
              ),
              value: "attributables.CARDSC",
            },
          ],
        },
      },
      detailFields9: {
        dettaglio_ev_nat: {
          header: "Dettaglio EVENTI NATURALI",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_ENATTA_value",
                "insurance_policy"
              ),
              value: "attributables.ENATTA",
            },
            {
              label: this.getDictionary(
                "attribute_ENATSC_value",
                "insurance_policy"
              ),
              value: "attributables.ENATSC",
            },
            {
              label: this.getDictionary(
                "attribute_ENATSCO_value",
                "insurance_policy"
              ),
              value: "attributables.ENATSCO",
            },
          ],
        },
      },
      detailFields10: {
        dettaglio_ev_soc_pol: {
          header: "Dettaglio EVENTI SOCIO POLITICI",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_ESOCTA_value",
                "insurance_policy"
              ),
              value: "attributables.ESOCTA",
            },
            {
              label: this.getDictionary(
                "attribute_ESOCSC_value",
                "insurance_policy"
              ),
              value: "attributables.ESOCSC",
            },
            {
              label: this.getDictionary(
                "attribute_ESOCSCO_value",
                "insurance_policy"
              ),
              value: "attributables.ESOCSCO",
            },
          ],
        },
      },
      detailFields11: {
        dettaglio_cristalli: {
          header: "Dettaglio CRISTALLI",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_CRITA_value",
                "insurance_policy"
              ),
              value: "attributables.CRITA",
            },
            {
              label: this.getDictionary(
                "attribute_CRISC_value",
                "insurance_policy"
              ),
              value: "attributables.CRISC",
            },
            {
              label: this.getDictionary(
                "attribute_CRISCO_value",
                "insurance_policy"
              ),
              value: "attributables.CRISCO",
            },
          ],
        },
      },
      detailFields12: {
        dettaglio_altro: {
          header: "Dettaglio ALTRO",
          edit: true,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "attribute_RPATFO_value",
                "insurance_policy"
              ),
              value: "attributables.RPATFO",
            },
            {
              label: this.getDictionary(
                "attribute_TUTGFO_value",
                "insurance_policy"
              ),
              value: "attributables.TUTGFO",
            },
            {
              label: this.getDictionary(
                "attribute_ASSFO_value",
                "insurance_policy"
              ),
              value: "attributables.ASSFO",
            },
            {
              label: this.getDictionary(
                "attribute_INFCOFO_value",
                "insurance_policy"
              ),
              value: "attributables.INFCOFO",
            },
          ],
        },
      },
    };
  },
  methods: {
    fetchForm() {
      this.isLoading = true;
      // let queryString = `relations/byAddressBook/byCorrespondence`;
      this.fetchShowForm(this.repository, this.resourceId)
        .then((response) => {
          const data = response.data.data;
          this.details = data;
          this.fetchEditForm(this.repository, this.resourceId)
            .then(() => {
              this.initDetailCardFormData();
              this.isLoading = false;
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onUpdate(form, repository) {
      this.isLoading = true;
      const Repo = RepositoryFactory.get(repository);

      let payload = {};
      payload = { ...this.mandatoryFields[repository] };

      // for (const key in payload) {
      //   if (
      //     payload[key] === null ||
      //     payload[key] === undefined ||
      //     payload[key] === ""
      //   ) {
      //     if (![null, undefined].includes(this.beForm[repository][key].value)) {
      //       payload[key] = this.beForm[repository][key].value;
      //     }
      //     if (this.beForm[repository][key] && ![null, undefined].includes(this.beForm[repository][key].value)) {
      //       payload[key] = this.beForm[repository][key].value;
      //     }
      //   }
      //   // if (this.beForm[repository][key].type === "select") {
      //   //   payload[key] = this.beForm[repository][key].value;
      //   // }
      // }

      this.setMandatoryValues(repository, payload);

      payload = { ...payload, ...form };
      // let resId =
      //   repository === this.repository
      //     ? this.resourceId
      //     : this.repositoryResourceId[repository].id;
      // if (repository === "address_book") {
      //   resId = addressBookId;
      // }
      // console.log(resId);
      // console.log(payload);
      Repo.update(this.resourceId, payload).then(() => {
        this.$emit("fetch");
        this.fetchForm();
      });
    },
  },
  computed: {
    detailFieldsTechData() {
      return this.detailFields1;
    },
    detailFieldsGuarantees() {
      return this.detailFields2;
    },
    /* */
    detailFieldsRca() {
      return this.detailFields3;
    },
    detailFieldsFurInc() {
      return this.detailFields4;
    },
    detailFieldsKasko() {
      return this.detailFields5;
    },
    detailFieldsEasyKask() {
      return this.detailFields6;
    },
    detailFieldsComplRca() {
      return this.detailFields7;
    },
    detailFieldsComplArd() {
      return this.detailFields8;
    },
    detailFieldsEvNat() {
      return this.detailFields9;
    },
    detailFieldsEvSocPol() {
      return this.detailFields10;
    },
    detailFieldsCrist() {
      return this.detailFields11;
    },
    detailFieldsAltro() {
      return this.detailFields12;
    },
    /* */
  },
  mounted() {
    this.fetchForm();
  },
};
</script>

<!--&lt;!&ndash; Add "scoped" attribute to limit CSS to this component only &ndash;&gt;-->
<!--<style lang="scss">-->
<!--[data-type="policy-tech-data"] {-->
<!--  .custom-grid-wrapper {-->
<!--    grid-template-columns: 200px 1fr;-->
<!--  }-->
<!--}-->

<!--</style>-->
